"use client"

import { useMemo } from "react"
import { useGetSignature } from "openapi/api/endpoints"
import { asArray } from "@/lib/as-array"

export function useMainSignature() {
  const { data: signatures, isLoading: isMainSignatureLoading } = useGetSignature()

  const mainSignature = useMemo(() => {
    const list = asArray<NonNullable<typeof signatures>[number]>(signatures)
    const selected =
      list.find((item) => item.is_default && item.is_active) ??
      list.find((item) => item.is_default) ??
      list.find((item) => item.is_active) ??
      list[0]

    if (!selected) return ""
    const signatureRecord = selected as { text?: string; text_signature?: string }
    return (signatureRecord.text ?? signatureRecord.text_signature ?? "").trim()
  }, [signatures])

  return { mainSignature, isMainSignatureLoading }
}
